import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useState } from "react";
import { Link } from "react-router-dom";

const themes = [
  { id: "all", label: "全部提案" },
  { id: "commute", label: "通勤氣質" },
  { id: "slim", label: "顯瘦修飾" },
  { id: "mature", label: "熟齡優雅" },
  { id: "date", label: "約會聚會" },
  { id: "seasonal", label: "換季推薦" },
];

const lookbooks = [
  {
    id: 1,
    theme: "commute",
    title: "都會通勤氣質穿搭",
    subtitle: "俐落、專業又不失優雅風範",
    tags: ["西裝外套", "修身長褲", "氣質上衣"],
    desc: "以知性西裝外套搭配修身長褲，展現都會女性的俐落與專業，細節處的質感面料讓整體穿搭更上一個層次。",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%20commute%20office%20look%20blazer%20tailored%20pants%20professional%20graceful%20urban%20warm%20cream%20beige%20background%20designer%20fashion%20editorial%20photography&width=600&height=800&seq=lk001&orientation=portrait",
    size: "large",
  },
  {
    id: 2,
    theme: "slim",
    title: "顯瘦修飾日常穿搭",
    subtitle: "聰明選搭，輕鬆展現好比例",
    tags: ["寬管長褲", "垂墜上衣", "長版外套"],
    desc: "選擇垂墜感面料與寬管剪裁，利用視覺延伸效果修飾腰腹，同時展現飄逸的女性優雅。",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20woman%20slimming%20outfit%20wide%20leg%20pants%20flowy%20draped%20top%20graceful%20silhouette%20cream%20neutral%20background%20designer%20fashion%20mature%20editorial&width=600&height=800&seq=lk002&orientation=portrait",
    size: "medium",
  },
  {
    id: 3,
    theme: "mature",
    title: "熟齡優雅日常穿搭",
    subtitle: "展現成熟女性的自信魅力",
    tags: ["優雅洋裝", "質感外套", "經典款式"],
    desc: "以修身洋裝為核心，搭配質感小外套，呈現熟齡女性特有的從容與優雅，每一件都是值得珍藏的經典。",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20woman%2050s%20graceful%20midi%20dress%20sophisticated%20style%20soft%20dusty%20rose%20warm%20background%20designer%20fashion%20quality%20fabric%20editorial%20photography&width=600&height=800&seq=lk003&orientation=portrait",
    size: "medium",
  },
  {
    id: 4,
    theme: "date",
    title: "優雅約會聚會穿搭",
    subtitle: "輕鬆展現迷人魅力",
    tags: ["印花洋裝", "荷葉細節", "優雅配色"],
    desc: "精選帶有浪漫細節的優雅洋裝，無論是下午茶、聚餐還是小旅行，都能穿出令人印象深刻的優雅氣質。",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20woman%20date%20outfit%20romantic%20floral%20midi%20dress%20graceful%20feminine%20warm%20rose%20beige%20background%20designer%20fashion%20mature%20elegant%20editorial&width=600&height=800&seq=lk004&orientation=portrait",
    size: "large",
  },
  {
    id: 5,
    theme: "seasonal",
    title: "換季必備外套穿搭",
    subtitle: "一件外套，多種穿搭可能",
    tags: ["長版外套", "針織上衣", "修身下著"],
    desc: "換季時節，一件剪裁精良的長版外套是最值得投資的單品，搭配簡潔內搭，輕鬆駕馭各種場合。",
    image: "https://readdy.ai/api/search-image?query=elegant%20taiwanese%20mature%20woman%20transitional%20season%20outfit%20long%20coat%20jacket%20layering%20graceful%20urban%20cream%20neutral%20background%20designer%20quality%20fashion%20editorial&width=600&height=800&seq=lk005&orientation=portrait",
    size: "medium",
  },
  {
    id: 6,
    theme: "commute",
    title: "一件多穿通勤示範",
    subtitle: "從辦公室到下班聚餐，無縫切換",
    tags: ["套裝組合", "質感配件", "百搭款式"],
    desc: "選對一套質感套裝，透過簡單的配件變換，輕鬆從辦公室的專業形象，轉換為下班後的優雅約會造型。",
    image: "https://readdy.ai/api/search-image?query=elegant%20mature%20taiwanese%20professional%20woman%20versatile%20outfit%20suit%20set%20graceful%20sophisticated%20warm%20beige%20cream%20background%20designer%20brand%20quality%20fashion%20editorial%20photography&width=600&height=800&seq=lk006&orientation=portrait",
    size: "medium",
  },
];

export default function Lookbook() {
  const [activeTheme, setActiveTheme] = useState("all");

  const filtered = activeTheme === "all" ? lookbooks : lookbooks.filter(l => l.theme === activeTheme);

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative h-[55vh] min-h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20taiwanese%20women%20fashion%20editorial%20lookbook%20multiple%20outfits%20warm%20cream%20rose%20beige%20tones%20designer%20brand%20quality%20sophisticated%20urban%20mature%20style%20fashion%20photography&width=1400&height=700&seq=lkhero&orientation=landscape"
            alt="穿搭提案"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/55" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-3">Style Inspiration</p>
            <h1 className="text-white text-[2.75rem] md:text-[3.25rem] font-bold leading-[1.3] mb-4">穿搭提案</h1>
            <p className="text-white/80 text-[1.1875rem] max-w-xl leading-[1.75]">
              不只是賣衣服，更是你的穿搭靈感夥伴。<br />讓每天的穿著都充滿自信與品味。
            </p>
          </div>
        </section>

        {/* Filter Tabs */}
        <section className="bg-white border-b border-[#ede8e0] sticky top-[72px] z-30">
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="flex items-center gap-2 py-4 overflow-x-auto">
              {themes.map(t => (
                <button
                  key={t.id}
                  onClick={() => setActiveTheme(t.id)}
                  className={`px-5 py-2 rounded-full text-[1rem] font-medium transition-all duration-200 cursor-pointer whitespace-nowrap flex-shrink-0 ${
                    activeTheme === t.id ? "bg-[#3d2b1f] text-[#faf8f5]" : "bg-[#f5ede4] text-[#7a6455] hover:bg-[#e8d8c8]"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Lookbook Grid */}
        <section className="py-16 md:py-24">
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filtered.map(item => (
                <div key={item.id} className="group rounded-lg overflow-hidden bg-white cursor-pointer flex flex-col">
                  <div className="relative overflow-hidden aspect-[3/4]">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#3d2b1f]/75 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                    <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                      <Link to="/shop" className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-[#3d2b1f] rounded-full text-[0.9375rem] font-semibold cursor-pointer whitespace-nowrap">
                        查看同款商品 <i className="ri-arrow-right-line"></i>
                      </Link>
                    </div>
                  </div>
                  <div className="p-5 flex flex-col flex-1">
                    <div className="flex flex-wrap gap-2 mb-3">
                      {item.tags.map(tag => (
                        <span key={tag} className="px-3 py-1 bg-[#f5ede4] text-[#8B5E52] text-[0.875rem] rounded-full font-medium">{tag}</span>
                      ))}
                    </div>
                    <h3 className="text-[#3d2b1f] text-[1.25rem] font-bold leading-[1.45] mb-1">{item.title}</h3>
                    <p className="text-[#8B5E52] text-[1rem] font-medium mb-3">{item.subtitle}</p>
                    <p className="text-[#7a6455] text-[1.0625rem] leading-[1.75]">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <section className="py-16 bg-[#3d2b1f] text-center px-6">
          <p className="text-[#c9a98a] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3">Try It On</p>
          <h2 className="text-[#f5e8d8] text-[2rem] md:text-[2.5rem] font-bold mb-4">想親自感受這些穿搭？</h2>
          <p className="text-[#c9a98a] text-[1.1875rem] mb-8 max-w-lg mx-auto leading-[1.75]">預約到台中門市試穿，讓我們的造型顧問為您量身打造最合適的優雅風格。</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/contact" className="px-8 py-3.5 bg-[#c9a98a] text-[#3d2b1f] rounded-full text-[1.0625rem] font-bold hover:bg-[#b8957a] transition-colors cursor-pointer whitespace-nowrap">預約試穿</Link>
            <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-8 py-3.5 border-2 border-[#c9a98a] text-[#c9a98a] rounded-full text-[1.0625rem] font-semibold hover:bg-[#c9a98a] hover:text-[#3d2b1f] transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-line-fill"></i> LINE 線上詢問
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
